/**
 * 金额格式化
 */
export function moneyFormat(data) {
  if (!data) return '0.00'
  // 将数据分割，保留两位小数
  data = parseInt(data).toFixed(2)
  // 获取整数部分
  const intPart = Math.trunc(data)
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  // 预定义小数部分
  let floatPart = '.00'
  // 将数据分割为小数部分和整数部分
  const newArr = data.toString().split('.')
  if (newArr.length === 2) { // 有小数部分
    floatPart = newArr[1].toString() // 取得小数部分
    return intPartFormat
  }
  return intPartFormat
}

/**
 * 读取svg文件
 * @filePath:svg文件路径
 */
const readFile = (filePath) => {
  // 创建一个新的xhr对象
  let xhr = null;
  if (window.XMLHttpRequest) {
    xhr = new XMLHttpRequest();
  } else {
    xhr = new ActiveXObject("Microsoft.XMLHTTP");
  }
  const okStatus = document.location.protocol === "file" ? 0 : 200;
  xhr.open("GET", filePath, false);
  xhr.overrideMimeType("image/svg+xml");
  xhr.send(null);
  return xhr.status === okStatus ? xhr.responseText : null;
}
/**
 * 过滤html标签
 * @param {any} str
 * @returns
 */
export function delHtmlTag(str) {
  return str.replace(/<[^>]+>/g, '')
}

export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * 请求参数去重，并去掉$与空值
 */
export function paramsFilter(params) {
  if (validatenull(params)) return
  const res = {}
  const map = new Map(Object.entries(params))
  map.forEach((value, key) => {
    if (key.includes('$') || validatenull(value)) return
    res[key] = value
  })
  return res
}

// 导出页面为PDF格式
import html2canvas from "html2canvas"
import JSPDF from "jspdf"

/***
* elementName: 需要输出PDF的页面id
* htmlTitle: 页面标题
* currentTime：创建时间
*/
export function exportPDF(elementName, htmlTitle, currentTime) {
  var element = document.getElementById(elementName)
  // 设置截图的分辨率（单位为dpi）
  const dpi = 300
  html2canvas(element, {
    logging: false,
    dpi: dpi, // 设置截图的分辨率
    scale: dpi / 96, // 设置截图缩放比例，以适应pdf的dpi
  }).then(function (canvas) {
    var pdf = new JSPDF("p", "mm", "a4") // A4纸，纵向
    var ctx = canvas.getContext("2d")
    var a4w = 210;
    var a4h = 297 // A4大小，210mm x 297mm，四边各保留20mm的边距
    var imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
    var renderedHeight = 0

    while (renderedHeight < canvas.height) {
      var page = document.createElement("canvas")
      page.width = canvas.width
      page.height = Math.min(imgHeight, canvas.height - renderedHeight) // 可能内容不足一页

      // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
      page.getContext("2d").putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
      pdf.addImage(page.toDataURL("image/jpeg", 1.0), "JPEG", 0, 0, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距


      renderedHeight += imgHeight
      if (renderedHeight < canvas.height) { pdf.addPage() } // 如果后面还有内容，添加一个空页
      // delete page;
    }
    pdf.save(htmlTitle + currentTime)
  })
}

export function exportPDFPage(elementName, htmlTitle, currentTime) {
  var element = document.getElementById(elementName)
  // 设置截图的分辨率（单位为dpi）
  const dpi = 300
  html2canvas(element, {
    logging: false,
    dpi: dpi, // 设置截图的分辨率
    scale: dpi / 96, // 设置截图缩放比例，以适应pdf的dpi
  }).then(function (canvas) {
    var contentWidth = parseInt(canvas.style.width) * 2;
    var contentHeight = parseInt(canvas.style.height) * 2;

    // console.log('contentWidth', contentWidth);
    // console.log('contentHeight', contentHeight);
    //一页pdf显示html页面生成的canvas高度;
    var pageHeight = (contentWidth / 592.28) * 841.89;
    //未生成pdf的html页面高度
    var leftHeight = contentHeight;
    //页面偏移
    var position = 0;
    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28;
    var imgHeight = (592.28 / contentWidth) * contentHeight;
    // console.log('imgHeight', imgHeight);
    var pageData = canvas.toDataURL('image/jpeg', 1.0);

    var pdf = new JSPDF('', 'pt', 'a4');
    var headerData = null
    html2canvas(document.getElementById('headerHTML'), {
      logging: false,
      dpi: dpi, // 设置截图的分辨率
      scale: dpi / 96, // 设置截图缩放比例，以适应pdf的dpi
    }).then(function (canvas) {
      headerData = canvas.toDataURL('image/jpeg', 1.0)
      var index = 0
      while (leftHeight > 0) {
        console.log(parseFloat(Math.abs(position)), '---', leftHeight)
        
        if (position < 0) {
          var newImg = document.createElement("canvas");
          newImg.width = imgWidth;
          newImg.height = imgHeight;
          var context = newImg.getContext("2d");
          context.rect(0, 0, newImg.width, newImg.height);
          context.fillStyle = "#fff";
          context.fill();
          var myImage = new Image();
          myImage.src = pageData;  //背景图片 你自己本地的图片或者在线图片
          myImage.onload = function () {
            context.drawImage(myImage, 0, 0, imgWidth, imgHeight)
            var myImage2 = new Image();
            myImage2.src = headerData;  //你自己本地的图片或者在线图片
            myImage2.onload = function () {
              index++
              context.drawImage(myImage2, 0, (index * 801.89), imgWidth, 40);
              var base64 = newImg.toDataURL('image/jpeg', 1.0)
              document.getElementById('cese').src = base64
              pdf.addImage(base64, 'JPEG', 0, position, imgWidth, imgHeight);
            }
          }
        } else{
          pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
        }
        leftHeight -= pageHeight;
        position -= 841.89;
        //避免添加空白页
        if (leftHeight < 100) {
          pdf.addPage();
        }
      }
      ////有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      ////当内容未超过pdf一页显示的范围，无需分页
      //if (leftHeight < pageHeight) {
      //  pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
      //} else {
      //  while (leftHeight > 0) {
      //    pdf.addImage(headerData, 'JPEG', 0, 0, imgWidth, 40);
      //    pdf.addImage(pageData, 'JPEG', 0, position + 40, imgWidth, imgHeight);
      //    leftHeight -= pageHeight;
      //    position -= 841.89;
      //    //避免添加空白页
      //    if (leftHeight > 100) {
      //      pdf.addPage();
      //    }
      //  }
      //}
      pdf.save(htmlTitle + currentTime)
    })
    
    
    
  })
}



// WEBPACK FOOTER //
// ./src/util/util.js